<template>
    <b-form-group style="margin: 0">
        <b-form-group label="手机号" label-align="right" label-cols="3">
            <b-form-input v-model="form.mobile" :disabled="lock" placeholder="11位手机号" :state="checkMobile"/>
            <b-form-invalid-feedback :state="checkMobile">手机号码不正确</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="验证码" label-align="right" label-cols="3">
            <b-input-group>
                <b-form-input v-model="form.code" placeholder="请发送并输入验证码"/>
                <b-input-group-append>
                    <b-btn variant="primary" :disabled="coder.disable" @click="sendSmsCode">{{coder.text}}</b-btn>
                </b-input-group-append>
            </b-input-group>
        </b-form-group>
    </b-form-group>
</template>

<script>
import {showMessage} from "@/utils";
import {sendCode} from "@/api/third/aliyun";

export default {
    name: "MobileCoder",
    props: {
        form: Object,
        lock: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            coder: {
                disable: false,
                counter: 60,
                text: '发送验证码',
                interval: null
            },
        }
    },
    computed: {
        checkMobile() {
            return this.form.mobile.length === 11 && this.form.mobile.startsWith('1')
        }
    },
    methods: {
        async sendSmsCode() {
            if (!this.form.mobile) {
                await showMessage('请输入手机号码！');
                return;
            }
            let res = await sendCode(this.form.mobile);
            if (res.code === 0) {
                this.coder = {
                    disable: true,
                    counter: 60,
                    text: '剩余(60s)',
                    interval: setInterval(() => {
                        this.coder.counter--;
                        this.coder.text = `剩余(${this.coder.counter}s)`;
                        if (this.coder.counter === 0) {
                            clearInterval(this.coder.interval);
                            this.coder = {
                                disable: false,
                                counter: 60,
                                text: '重新发送',
                                interval: null
                            };
                        }
                    }, 1000, 0)
                };
            } else {
                await showMessage(res.message);
            }
        },
    }
}
</script>

<style scoped>

</style>